<div id="settings-trigger" (click)="toggleThemeSettings()">
  <i class="mdi mdi-cog"></i>
</div>
<div id="theme-settings" class="settings-panel">
  <i class="settings-close mdi mdi-close" (click)="closeSettingsSidebar('theme')"></i>
  <p class="settings-heading">SIDEBAR SKINS</p>
  <div class="sidebar-bg-options selected" id="sidebar-default-theme" (click)="changeSidebarTheme('light')">
    <div class="img-ss rounded-circle bg-light border ms-3"></div>
    Default
  </div>
  <div class="sidebar-bg-options" id="sidebar-dark-theme" (click)="changeSidebarTheme('dark')">
    <div class="img-ss rounded-circle bg-dark border ms-3"></div>
    Dark
  </div>
  <p class="settings-heading mt-2">HEADER SKINS</p>
  <div class="color-tiles mx-0 px-4">
    <div class="tiles primary" (click)="changeNavbarTheme('primary')"></div>
    <div class="tiles success" (click)="changeNavbarTheme('success')"></div>
    <div class="tiles warning" (click)="changeNavbarTheme('warning')"></div>
    <div class="tiles danger" (click)="changeNavbarTheme('danger')"></div>
    <div class="tiles info" (click)="changeNavbarTheme('info')"></div>
    <div class="tiles dark" (click)="changeNavbarTheme('dark')"></div>
    <div class="tiles default light" (click)="changeNavbarTheme('default')"></div>
  </div>
  <p class="settings-heading mt-2">LAYOUT OPTIONS</p>
  <div class="layout-variations px-4 mx-2 mt-3">
    <div class="form-check layout-item">
      <label class="form-check-label">
        <input type="radio" class="form-check-input" name="layout-variations" [checked]="isDefaultLayout"
               (change)="changeLayout('default')"/>
        Default
        <i class="input-helper"></i>
      </label>
    </div>
    <div class="form-check layout-item">
      <label class="form-check-label">
        <input type="radio" class="form-check-input" name="layout-variations" [checked]="isBoxedLayout"
               (change)="changeLayout('boxed')"/>
        Boxed Layout
        <i class="input-helper"></i>
      </label>
    </div>
    <div class="form-check layout-item">
      <label class="form-check-label">
        <input type="radio" class="form-check-input" name="layout-variations" [checked]="isSidebarIconOnly"
               (change)="changeLayout('icon-menu')"/>
        Icon Menu
        <i class="input-helper"></i>
      </label>
    </div>
    <div class="form-check layout-item">
      <label class="form-check-label">
        <input type="radio" class="form-check-input" name="layout-variations" [checked]="isCompactMenu"
               (change)="changeLayout('compact-menu')"/>
        Compact Menu
        <i class="input-helper"></i>
      </label>
    </div>
    <div class="form-check layout-item">
      <label class="form-check-label">
        <input type="radio" class="form-check-input" name="layout-variations" [checked]="isFixedSidebar"
               (change)="changeLayout('fixed-sidebar')"/>
        Fixed Sidebar
        <i class="input-helper"></i>
      </label>
    </div>
    <div class="form-check layout-item">
      <label class="form-check-label">
        <input type="radio" class="form-check-input" name="layout-variations" [checked]="isHiddenSidebar"
               (change)="changeLayout('hidden-sidebar')"/>
        Hidden Sidebar
        <i class="input-helper"></i>
      </label>
    </div>
    <div class="form-check layout-item">
      <label class="form-check-label">
        <input type="radio" class="form-check-input" name="layout-variations" [checked]="isOverlaySidebar"
               (change)="changeLayout('overlay-sidebar')"/>
        Overlay Sidebar
        <i class="input-helper"></i>
      </label>
    </div>
  </div>
</div>
<div id="right-sidebar" class="settings-panel">
  <i class="settings-close mdi mdi-close" (click)="closeSettingsSidebar('main')"></i>
  <div class="border-top right-sidebar-tab">
    <ul ngbNav #nav="ngbNav" [(activeId)]="active" class="nav-tabs">
      <li [ngbNavItem]="1">
        <button ngbNavLink>EVENTS</button>
        <ng-template ngbNavContent>
          <div class="px-3">
            <h4 class="px-3 text-muted mt-5 fw-light mb-0">Events</h4>
            <div class="events pt-4 px-3">
              <div class="wrapper d-flex mb-2">
                <i class="mdi mdi-checkbox-blank-circle-outline text-primary me-2"></i>
                <span>Feb 11 2018</span>
              </div>
              <p class="mb-0 fw-thin text-gray">
                Creating component page build a js
              </p>
              <p class="text-gray mb-0">The total number of sessions</p>
            </div>
            <div class="events pt-4 px-3">
              <div class="wrapper d-flex mb-2">
                <i class="mdi mdi-checkbox-blank-circle-outline text-primary me-2"></i>
                <span>Feb 7 2018</span>
              </div>
              <p class="mb-0 fw-thin text-gray">Meeting with Alisa</p>
              <p class="text-gray mb-0">Call Sarah Graves</p>
            </div>
          </div>
        </ng-template>
      </li>
      <li [ngbNavItem]="2">
        <button ngbNavLink>CHATS</button>
        <ng-template ngbNavContent>
          <div class="d-flex align-items-center justify-content-between border-bottom">
            <p class="settings-heading border-top-0 mb-3 ps-3 pt-0 border-bottom-0 pb-0">
              Friends
            </p>
            <small class="settings-heading border-top-0 mb-3 pt-0 border-bottom-0 pb-0 pe-3 fw-normal">See All</small>
          </div>
          <ul class="chat-list">
            <li class="list active">
              <div class="profile">
                <img src="assets/images/faces/face1.jpg" alt="image"/><span class="online"></span>
              </div>
              <div class="info">
                <p>Thomas Douglas</p>
                <p>Available</p>
              </div>
              <small class="text-muted my-auto">19 min</small>
            </li>
            <li class="list">
              <div class="profile">
                <img src="assets/images/faces/face2.jpg" alt="image"/><span class="offline"></span>
              </div>
              <div class="info">
                <div class="wrapper d-flex">
                  <p>Catherine</p>
                </div>
                <p>Away</p>
              </div>
              <div class="badge badge-success badge-pill my-auto mx-2">4</div>
              <small class="text-muted my-auto">23 min</small>
            </li>
            <li class="list">
              <div class="profile">
                <img src="assets/images/faces/face3.jpg" alt="image"/><span class="online"></span>
              </div>
              <div class="info">
                <p>Daniel Russell</p>
                <p>Available</p>
              </div>
              <small class="text-muted my-auto">14 min</small>
            </li>
            <li class="list">
              <div class="profile">
                <img src="assets/images/faces/face4.jpg" alt="image"/><span class="offline"></span>
              </div>
              <div class="info">
                <p>James Richardson</p>
                <p>Away</p>
              </div>
              <small class="text-muted my-auto">2 min</small>
            </li>
            <li class="list">
              <div class="profile">
                <img src="assets/images/faces/face5.jpg" alt="image"/><span class="online"></span>
              </div>
              <div class="info">
                <p>Madeline Kennedy</p>
                <p>Available</p>
              </div>
              <small class="text-muted my-auto">5 min</small>
            </li>
            <li class="list">
              <div class="profile">
                <img src="assets/images/faces/face6.jpg" alt="image"/><span class="online"></span>
              </div>
              <div class="info">
                <p>Sarah Graves</p>
                <p>Available</p>
              </div>
              <small class="text-muted my-auto">47 min</small>
            </li>
          </ul>
        </ng-template>
      </li>
    </ul>
    <div [ngbNavOutlet]="nav" class="mt-2"></div>
  </div>
</div>
